import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import GameConfig from "../model/GameConfig";
import ProgressDotsView from "./ProgressDotsView";

export default class TutorialOverlayMediator extends AbstractPopupMediator {

    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {somajs.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {GameConfig} gameConfig 
     */
    constructor(target, dispatcher, languagePack, layoutManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;
    }


    initialize() {
        super.initialize();

        const n = this._target.totalFrames;
        for (let f = 1; f <= n; f++) {
            //block clicks through panel, quick and dirty
            this._target["bg" + f].addEventListener("click", () => { });
        }
        
        this._progressView = new ProgressDotsView(this._target.progressDots, n);

        this._buttonNext = this.createButton(this._target.nextButton, this._handleNext.bind(this), this.getText("tutorial.buttonNext"));
        this._buttonPrev = this.createButton(this._target.prevButton, this._handlePrev.bind(this), this.getText("tutorial.buttonPrev"));
        this._buttonStart = this.createButton(this._target.button, this._handleNext.bind(this), this.getText("tutorial.buttonStart"));
        this._setPage(0);
        
        if (ranj.DEBUG) {
            this._handleKeyUp = this._handleKeyUp.bind(this);
            window.document.addEventListener('keyup', this._handleKeyUp);
        }
    }

    destroy() {
        super.destroy();
        if (ranj.DEBUG) {
            window.document.removeEventListener('keyup', this._handleKeyUp);
        }
    }

    _handleKeyUp(e) {
        const c = String.fromCharCode(e.which);
        if (c == "X") this._changePage(99);
    }

    _handleNext() {
        this._changePage(1);
    }
    _handlePrev() {
        this._changePage(-1);
    }


    _changePage(delta) {
        const f = Math.max(0, this._target.currentFrame + delta);
        const n = this._target.totalFrames;
        if (f >= n) {
            this._buttonPrev.setEnabled(false);
            this._buttonNext.setEnabled(false);
            this._buttonStart.setEnabled(false);
            this.close();
        } else {
            const duration = this._gameConfig.getValue("tutorial.crossFadeDuration");
            const wait = this._gameConfig.getValue("tutorial.crossFadeDelay");
            createjs.Tween.get(this._target)
                .to({ alpha: 0 }, duration, createjs.Ease.quadOut)
                .call(() => {
                    this._setPage(f);
                })
                .wait(wait)
                .to({ alpha: 1 }, duration, createjs.Ease.quadIn);
        }
    }

    _setPage(idx) {
        this._target.gotoAndStop(idx);
        const n = this._target.totalFrames;
        this._buttonPrev.setEnabled(idx > 0);
        this._buttonNext.setVisible(idx < n - 1);
        this._buttonStart.setVisible(idx == n - 1);
        this._progressView.setProgress(idx);
        
        const prefix = "tutorial.overlay" + (idx + 1) + ".";
        this._target.bodyTextfield.text = this.getText(prefix + "body");
        this._target.titleTextfield.text = this.getText(prefix + "title");

        const anchorStr = this._gameConfig.getValue("tutorial.anchoring")[idx];
        let anchor;
        if (anchorStr) {
            anchor = Anchor[anchorStr];
        } else {
            anchor = Anchor.C;
        }
        this.unanchorObject(this._target, true);
        this.anchorObject(this._target, anchor);
    }
};


const isTouch = window.ontouchstart !== undefined || getURLParameter("touch") == "1";